import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/vercel/path0/app/_components/Avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Base"] */ "/vercel/path0/app/_components/Base.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayButton"] */ "/vercel/path0/app/_components/PlayButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceErrorReporter"] */ "/vercel/path0/app/_components/ResourceErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Splash"] */ "/vercel/path0/app/_components/Splash.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Switch"] */ "/vercel/path0/app/_components/Switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WatchPartyBanner"] */ "/vercel/path0/app/_components/WatchPartyBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/global.css");
